'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldRequireConsentToCommunicate = undefined;

var _reselect = require('reselect');

var _gdprConsentToCommunicateEnabled = require('conversations-schema/operators/widget-data/gdprConsentToCommunicateEnabled');

var _getWidgetData = require('./getWidgetData');

var shouldRequireConsentToCommunicate = exports.shouldRequireConsentToCommunicate = (0, _reselect.createSelector)([_getWidgetData.getWidgetData], function (widgetData) {
  return (0, _gdprConsentToCommunicateEnabled.gdprConsentToCommunicateEnabled)(widgetData);
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/shouldRequireConsentToCommunicate.js
// module id = 633
// module chunks = 2 3